// Validates the server-provided controls before V3 renders editable settings.
import { z } from 'zod';

const fieldBase = {
    key: z.string().regex(/^[a-z][a-z0-9_]{0,99}$/),
    label: z.string().min(1).max(200),
};
export const settingsApprovalEditorSchema = z
    .object({
        kind: z.literal('settings'),
        title: z.string().min(1).max(200),
        fields: z
            .array(
                z.discriminatedUnion('kind', [
                    z
                        .object({
                            ...fieldBase,
                            kind: z.literal('toggle'),
                            current: z.boolean().nullable(),
                            proposed: z.boolean(),
                        })
                        .strict(),
                    z
                        .object({
                            ...fieldBase,
                            kind: z.literal('number'),
                            current: z.number().nullable(),
                            proposed: z.number().nullable(),
                            nullable: z.boolean(),
                            step: z.literal(1).nullable(),
                            min: z.number().optional(),
                            max: z.number().optional(),
                        })
                        .strict(),
                ]),
            )
            .min(1)
            .max(30)
            .refine(
                (fields) =>
                    new Set(fields.map((field) => field.key)).size ===
                    fields.length,
            ),
    })
    .strict();
export type SettingsApprovalEditor = z.infer<
    typeof settingsApprovalEditorSchema
>;
